import React from "react";
import styled from "styled-components";
import {CtaWireframeButton, Form, Label, TextInput} from "../../style/itf-styled-components";

const SubscribeLabel = styled(Label)`
  margin-right: 15px;
  width: 30vw;
  max-width: 350px;
  
  @media (max-width: 768px) {
    width: 50vw;
  }
`;
const SubscribeInput = styled(TextInput)``;


class NewsletterForm extends React.Component {
  componentDidMount() {
    document.querySelectorAll('.subscribeButton').forEach(button => {
      button.addEventListener('click', function(_) {
        if (typeof window !== "undefined") {
          if (window.fbq != null) {
            window.fbq('track', 'Subscribe');
          }
        }
      }, false)
    })
  }

  render() {
    return (
      <Form
        action="https://imaginetimisoara.us20.list-manage.com/subscribe/post?u=f9fd49b55d645652d135d6667&amp;id=61093e49a7"
        method="post"
        target="_blank"
        noValidate
      >
        <SubscribeLabel>
          <SubscribeInput
            type="email"
            name="EMAIL"
            placeholder="Email"
          />
        </SubscribeLabel>
        <CtaWireframeButton
          className="subscribeButton"
          modifier="cta"
          type="submit"
        >Mă abonez!</CtaWireframeButton>
      </Form>
    );
  }
}

export default NewsletterForm;